import { ScreenHeader } from '@components/v2/layout/ScreenHeader/ScreenHeader';
import { ScreenHeaderPrimaryAction } from '@components/v2/layout/ScreenHeader/screenHeader.types';
import { ReactNode } from 'react';

interface ListScreenHeaderProps {
  breadcrumb: ReactNode;
  primaryAction?: ScreenHeaderPrimaryAction;
  actions?: ReactNode;
}

export function ListScreenHeader({ breadcrumb, primaryAction, actions }: ListScreenHeaderProps) {
  return <ScreenHeader breadcrumb={breadcrumb} actions={actions} primaryAction={primaryAction} />;
}
